exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stories-cta[data-v-02ac6770]{text-align:center;margin-top:36px}@media (max-width:900px){.stories[data-v-02ac6770]{grid-template-columns:repeat(2,1fr);padding:0}.story.s1[data-v-02ac6770],.story.s2[data-v-02ac6770],.story.s4[data-v-02ac6770]{grid-column:span 2;grid-row:auto}}", ""]);

// exports
